// File: config.breadcrumbs.js
// Author: Joseph M Diaz
// Date: 4/27/2017
// Desc: Configuration items for the breadcrumbs component.
// Other Contributors:

const rootBreadcrumb = {
    iconClass: 'fa fa-lg fa-home',
    link: {
        enabled: true,
        url: '/'
    }
};

export const breadcrumbs = {
    '': rootBreadcrumb,
    'logged-out': [
        rootBreadcrumb,
        {
            name: 'Logged Out',
            link: { enabled: false }
        }
    ],
    '404': [
        rootBreadcrumb,
        {
            name: 'Page Not Found',
            link: { enabled: false }
        }
    ],
    'VE':
    {
        name: 'VE',
        link: { enabled: true, url: '#/VE' }
    },
    'Administration':
    {
        name: 'Administration',
        link: { enabled: false, url: '' }
    },
    'Architecture':
    {
        name: 'Architectures',
        link: { enabled: true, url: '#/VE/Administration/Architecture' }
    },
    'SMT':
    {
        name: 'SMTs',
        link: { enabled: true, url: '#/VE/Administration/SMT' }
    },
    'Gate':
    {
        name: 'Gates',
        link: { enabled: true, url: '#/VE/Administration/Gate' }
    },
    'mBOM':
    {
        name: 'mBOMs',
        link: { enabled: true, url: '#/VE/Administration/mBOM' }
    },
    'Tooling-Operator-Interfaces':
    {
        name: 'Tooling Operator Interfaces',
        link: { enabled: true, url: '#/VE/Administration/Tooling-Operator-Interfaces' }
    },
    'Request-Type':
    {
        name: 'Request Types',
        link: { enabled: true, url: '#/VE/Administration/Request-Type' }
    },
    'Deliverables':
    {
        name: 'Deliverables',
        link: { enabled: true, url: '#/VE/Administration/Deliverables' }
    },
    'Additional-Information-Category':
    {
        name: 'Additional Information Categories',
        link: { enabled: true, url: '#/VE/Administration/Additional-Information-Category' }
    },
    'CME-Area':
    {
        name: 'CME Areas',
        link: { enabled: true, url: '#/VE/Administration/CME-Area' }
    },
    'Study-Titles':
        {
            name: 'Study Titles',
            link: { enabled: true, url: '#/VE/Administration/Study-Titles' }
        },
    'Total-Vehicle-Number':
    {
        name: 'Total Vehicle Numbers',
        link: { enabled: true, url: '#/VE/Administration/Total-Vehicle-Number' }
    },
    'Tracking-Vehicle-Number':
    {
        name: 'Tracking Vehicle Numbers',
        link: { enabled: true, url: '#/VE/Administration/Tracking-Vehicle-Number' }
    },
    'Banner':
    {
        name: 'Banner Message',
        link: { enabled: true, url: '#/VE/Administration/Banner' }
    },
    'Areas':
    {
        name: 'Areas',
        link: { enabled: true, url: '#/VE/Administration/Areas' }
    },
    'Ga-Program-Details':
    {
        name: 'Program Details',
        link: { enabled: true, url: '#/VE/Administration/Ga-Program-Details' }
    },
    'Body-Program-Details':
    {
        name: 'Program Details',
        link: { enabled: true, url: '#/VE/Administration/Body-Program-Details' }
    },
    'Default-Notification-Contacts':
    {
        name: 'Default Notification Contacts',
        link: { enabled: true, url: '#/VE/Administration/Default-Notification-Contacts' }
    },
    'Holiday-Schedule':
    {
        name: 'Holiday Schedules',
        link: { enabled: true, url: '#/VE/Administration/Holiday-Schedule' }
    },
    'Work-Order-Schedule':
    {
        name: 'Work Order Schedule',
        link: { enabled: true, url: '#/VE/Work-Order-Schedule' }
    },
    'Engineer-Schedule':
    {
        name: 'Engineer Schedule',
        link: { enabled: true, url: '#/VE/Engineer-Schedule' }
    },
    'Work-Orders':
    {
        name: 'Work Orders',
        link: { enabled: true, url: '#/VE/Work-Orders' }
    },
    'Reports':
    {
        name: 'Work Orders Reports',
        link: { enabled: true, url: '#/VE/Work-Orders/Reports' }
    },
    'Search':
    {
        name: 'Work Orders Search',
        link: { enabled: true, url: '#/VE/Work-Orders/Search' }
    },
    'Ga-Wo-Add':
    {
        name: 'Add New GA Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Ga-Wo-Add' }
    },
    'Ga-Wo-Edit':
    {
        name: 'Edit GA Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Ga-Wo-Edit' }
    },
    'Ga-Wo-Copy':
    {
        name: 'Copy GA Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Ga-Wo-Copy' }
    },
    'Ga-Wo-View':
    {
        name: 'View GA Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Ga-Wo-View' }
    },
    'Ga-Wo-Add-Multiple':
    {
        name: 'Add Multiple GA Work Orders',
        link: { enabled: true, url: '#/VE/Work-Orders/Ga-Wo-Add-Multiple' }
    },
    'Body-Wo-Add':
    {
        name: 'Add New Body Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Body-Wo-Add' }
    },
    'Body-Wo-Edit':
    {
        name: 'Edit Body Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Body-Wo-Edit' }
    },
    'Body-Wo-Copy':
    {
        name: 'Copy Body Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Body-Wo-Copy' }
    },
    'Body-Wo-View':
    {
        name: 'View Body Work Order',
        link: { enabled: true, url: '#/VE/Work-Orders/Body-Wo-View' }
    },
    'Body-Wo-Submit-Report':
    {
        name: 'Submit Body Work Order Report',
        link: { enabled: true, url: '#/VE/Work-Orders/Body-Wo-Submit-Report' }
    },
    'Body-Wo-Add-Multiple':
    {
        name: 'Add Multiple Body Work Orders',
        link: { enabled: true, url: '#/VE/Work-Orders/Body-Wo-Add-Multiple' }
    },
};
